<script lang="ts">
	export let qnNumber: string;
	import QnComponent from './QnComponent.svelte';
	import {uqnArray,selected} from './stores.js';
	import getRandomInt from './functions/getRandomInt'
	import Button, {Label} from '@smui/button';
	import random from './check_random/random';
	import FormField from '@smui/form-field';
	import Checkbox from '@smui/checkbox';
	import Katex from './Katex.svelte'

	const options = [
		{k: 1, t: ''},
		{k: 2, t: 'Multiplication'},
		{k: 3, t: 'Division'},
		{k: 4, t: 'Powers'},
		{k: 5, t: 'Linear equation'},
		{k: 6, t: 'Quadratic equation'}
	]

	function addRandomItemOne() {
		addRandomItem();
	}
	function addRandomItemFive() {
		addRandomItem(5);
	}
	function addRandomItem(n=1) {
		let optionArray = [0];
		if ($selected.length > 0){
			optionArray = $selected;
		}
		for (let i=0; i < n; i++) {
			if ($uqnArray.length < 26){
				let index = getRandomInt(0, optionArray.length - 1);
				let newUQN = random(optionArray[index]);
				$uqnArray = [...$uqnArray, newUQN];
			}
		}
	}
	function resetUQNs() {
		$uqnArray = [$uqnArray[0]];
	}
	function randomizeUQNs(optionArray) {
		if (optionArray.length == 0) {
			optionArray = [0];
		}
		$uqnArray.forEach( (uqn, id) => {
			let index = getRandomInt(0, optionArray.length - 1);
			$uqnArray[id] = random(optionArray[index]);
		})
		$uqnArray = $uqnArray;
	}

</script>

<h2>Question {qnNumber}</h2>
{#each $uqnArray as uqn, id}
<QnComponent uqn={uqn} qnNameCode={id}/>
{/each}
<hr>
Choose the type of question: <br>
{#each options as option}
	<FormField>
		<Checkbox bind:group={$selected} value={option.k} />
			{#if option.k!=1}<span>{option.t}</span>
			{:else}<Katex math="i^n"/>
			{/if}
	</FormField>
{/each}
<hr>
<Button on:click={addRandomItemOne} variant="unelevated" class="button-shaped-round">
	<Label>Add 1 Question</Label>
</Button>
<Button on:click={addRandomItemFive} variant="unelevated" class="button-shaped-round">
	<Label>Add 5 Questions</Label>
</Button>
<Button on:click={resetUQNs} variant="unelevated" class="button-shaped-round">
	<Label>Reset</Label>
</Button>
<br>
<Button on:click={randomizeUQNs($selected)} variant="unelevated" class="button-shaped-round">
	<Label>Randomize Question(s)</Label>
</Button>
<hr>
